<template>
   <b-container>
      <b-row class="mt-5">
         <b-col>
            <b-breadcrumb class="p-0 my-1" :items="breadcrumbs"/>
            <h2>Device Pairing
               <hr class="left mt-1 mb-4"/>
            </h2>
         </b-col>
      </b-row>
      <b-row>
         <b-col>

               <p class="text-muted">
                  Open this page on your other device's camera, or scan the code with the camera app.
                  After scanning, that device will be logged in as you. The code is valid for {{ ttlSeconds }}
                  seconds and can be used once.
               </p>

               <div v-if="busy" class="text-center my-4">
                  <b-spinner/>
               </div>

               <div v-else-if="qrCodeDataUrl" class="text-center">
                  <img :src="qrCodeDataUrl" alt="Device pairing QR code"/>
                  <p class="mt-3 small text-muted text-break">{{ pairingUrl }}</p>
                  <p v-if="secondsLeft > 0" class="mt-2">
                     Expires in <strong>{{ secondsLeft }}s</strong>
                  </p>
                  <p v-else class="mt-2 text-danger">Code expired.</p>
                  <b-button variant="primary" class="mt-2" @click="generate">
                     Generate new code
                  </b-button>
               </div>

               <b-alert v-if="error" variant="danger" show class="mt-3">{{ error }}</b-alert>

         </b-col>
      </b-row>
   </b-container>
</template>

<script>
import QRCode from 'qrcode';
import DevicePairingApi from '@shared/_api/devicePairing';

export default {
   name: 'device-pairing',
   data() {
      return {
         busy: false,
         error: null,
         qrCodeDataUrl: null,
         pairingUrl: '',
         ttlSeconds: 60,
         secondsLeft: 0,
         timer: null
      };
   },
   methods: {
      generate() {
         this.busy = true;
         this.error = null;
         this.qrCodeDataUrl = null;
         this.stopTimer();

         DevicePairingApi.create().then(({token, expiresIn}) => {
            this.ttlSeconds = expiresIn;
            this.secondsLeft = expiresIn;
            this.pairingUrl = `${window.location.origin}/pair?token=${encodeURIComponent(token)}`;
            return QRCode.toDataURL(this.pairingUrl, {width: 300});
         }).then(dataUrl => {
            this.qrCodeDataUrl = dataUrl;
            this.startTimer();
         }).catch(err => {
            this.error = (err && err.message) || 'Could not generate pairing code.';
         }).finally(() => {
            this.busy = false;
         });
      },
      startTimer() {
         this.timer = setInterval(() => {
            this.secondsLeft = Math.max(0, this.secondsLeft - 1);
            if (this.secondsLeft === 0) this.stopTimer();
         }, 1000);
      },
      stopTimer() {
         if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
         }
      }
   },
   computed: {
      breadcrumbs() {
         return [{
            text: 'Home',
            href: '/'
         }, {
            text: 'Device Pairing',
            href: ''
         }]
      },
   },
   created() {
      this.generate();
   },
   beforeDestroy() {
      this.stopTimer();
   }
};
</script>
